import { render, staticRenderFns } from "./nucleic-successful.vue?vue&type=template&id=84d1799e&"
import script from "./nucleic-successful.vue?vue&type=script&lang=js&"
export * from "./nucleic-successful.vue?vue&type=script&lang=js&"
import style0 from "./nucleic-successful.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports